import { Vue, Component } from 'vue-property-decorator';
import ClButtonBase from '../ClButtonBase';

@Component({
  components: {
    ClButtonBase
  }
})
export default class ClCardActionArea extends Vue {}
